import 'jquery';
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { unregister } from './registerServiceWorker';
import { createStandardPublicClientApplication } from '@azure/msal-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { msalConfig } from './authConfig';

const inAuthFrame = window.self !== window.top;
const hasAuthResponse = /[#&?](code|error)=/.test(window.location.hash + window.location.search);

if (inAuthFrame && hasAuthResponse) {
  broadcastResponseToMainFrame().catch(console.error);
} else {
  const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
  const rootElement = document.getElementById('root');

  const root = ReactDOMClient.createRoot(rootElement);

  createStandardPublicClientApplication(msalConfig)
    .then(publicClientApp =>
      root.render(<BrowserRouter basename={baseUrl}>
        <App pca={publicClientApp} />
      </BrowserRouter>))
    .catch(console.error);

  unregister();
}
